
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M10.5 1.5h-6A1.5 1.5 0 0 0 3 3v12a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 15 15V6z"}}),_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M10.5 1.5V6H15M7.6 11.039l-.7.269-.7.27M11.8 9.423l-.7.27-.7.268M8.461 9.1l-.269-.7-.27-.7M10.077 13.3l-.27-.7-.268-.7"}})])
          )
        }
      }
    